"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPhoneUpsolve = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconPhoneUpsolve = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "21",
    height: "39",
    viewBox: "0 0 21 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M10.5654 12.5212L12.7215 10.0563V10.0108H7V13.4357C7 14.1157 7.30129 14.7678 7.83762 15.2487C8.37394 15.7296 9.10138 15.9998 9.85996 16V16C10.2356 16 10.6076 15.9337 10.9547 15.8048C11.3018 15.6759 11.6172 15.4871 11.8828 15.2489C12.1485 15.0108 12.3592 14.7281 12.503 14.417C12.6467 14.1059 12.7207 13.7725 12.7207 13.4357V12.5212H10.5654Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M16.7505 10.0147L13.7589 10V10.0538L15.9215 12.5212H13.7437L13.7361 13.7808V14.0228C13.7345 14.2813 13.7898 14.5376 13.8989 14.7769C14.0079 15.0162 14.1685 15.234 14.3714 15.4176C14.5744 15.6012 14.8158 15.7472 15.0818 15.8471C15.3478 15.9471 15.6331 15.999 15.9215 16V14.0634L16.7385 14.0465C17.0339 14.048 17.3266 13.9973 17.6001 13.8973C17.8736 13.7974 18.1225 13.6501 18.3324 13.4639C18.5424 13.2778 18.7095 13.0564 18.824 12.8123C18.9385 12.5683 18.9983 12.3065 18.9999 12.0417C18.9999 11.506 18.7633 10.992 18.3418 10.6122C17.9203 10.2324 17.3482 10.0175 16.7505 10.0147Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.72969 32.5094C6.62524 32.5094 6.51923 32.5063 6.41167 32.5C6.08118 32.4798 5.8302 32.1976 5.84888 31.8671C5.86914 31.5366 6.15131 31.2841 6.48178 31.3059C7.32205 31.3543 7.9113 31.1641 8.28388 30.7214C8.98228 29.8889 8.79363 28.2723 8.66114 27.7205C8.61282 27.5193 8.67205 27.3089 8.81547 27.1624C10.0657 25.8856 10.6176 24.8084 10.4103 24.0461C10.2622 23.4989 9.72902 23.1762 9.3876 23.0203L4.65767 27.5862C4.41915 27.8154 4.04032 27.8092 3.81117 27.5722C3.58201 27.3337 3.58825 26.9549 3.8252 26.7257L8.82611 21.8948C8.97733 21.7483 9.19558 21.6922 9.39824 21.7483C9.46995 21.7685 11.1583 22.2409 11.5636 23.7312C11.8785 24.8864 11.3142 26.2442 9.88775 27.7704C10.0094 28.5109 10.1777 30.3176 9.20181 31.4868C8.63435 32.1665 7.80346 32.5095 6.72937 32.5095L6.72969 32.5094Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M12.8082 38.5192H11.6109V35.8067H1.19725V38.5192H0V35.208C0 34.8775 0.268136 34.6094 0.598625 34.6094H12.2096C12.54 34.6094 12.8082 34.8775 12.8082 35.208V38.5192Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.6496 35.208H10.4524V34.3787C10.4524 34.1682 10.5631 33.9718 10.7439 33.8642C11.2443 33.5649 12.3278 32.7464 12.4743 32.1307C12.6614 31.3465 12.5304 29.892 12.4634 29.3979L13.6497 29.2388C13.6607 29.3199 13.9163 31.2499 13.6388 32.4097C13.3972 33.4245 12.2202 34.3225 11.6496 34.706L11.6496 35.208Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M2.04539 35.208H0.848145V24.3437L5.16024 20.5213L5.95374 21.4177L2.04551 24.8831L2.04539 35.208Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M17.7951 29.705H9.56399V28.5078H17.7935C18.3017 28.5078 18.654 28.4033 18.8676 28.1882C19.3243 27.7283 19.3165 26.6371 19.3072 25.3759C19.3056 25.1873 19.3041 24.9971 19.3041 24.8022V4.90114C19.3041 2.16834 19.0235 1.19717 17.4427 1.19717H7.95532C6.4042 1.19717 6.15633 2.07639 6.15633 4.90114V25.7113H4.95908L4.95752 4.90114C4.95752 2.71708 4.95752 0 7.95376 0H17.4428C20.5014 0 20.5014 2.83413 20.5014 4.90114V24.8022C20.5014 24.994 20.5029 25.181 20.5045 25.3666C20.5154 26.8959 20.5263 28.2178 19.7172 29.0316C19.2682 29.4852 18.6385 29.705 17.7951 29.705L17.7951 29.705Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M15.8152 1.40269C15.8152 1.84699 15.2758 2.20864 14.6101 2.20864H10.8547C10.189 2.20864 9.64966 1.84853 9.64966 1.40269C9.64966 0.95839 10.1891 0.598297 10.8547 0.598297H14.6101C15.2758 0.598297 15.8152 0.958406 15.8152 1.40269Z",
      fill: color
    }, void 0)]
  }), void 0);
});